const sourceTypeData = [
    {
        id: 0,
        name: 'All',
        checked: false,
    },
    {
        id: 1,
        name: 'Curbside',
        checked: false,
    },
    {
        id: 2,
        name: 'Online',
        checked: false,
    },
    {
        id: 3,
        name: 'Walkup',
        checked: false,
    },
    {
        id: 4,
        name: 'Text to Pay',
        checked: false,
    },
    {
        id: 5,
        name: 'Kiosk',
        checked: false,
    },
    {
        id: 6,
        name: 'Scan to pay',
        checked: false,
    },
    {
        id: 7,
        name: 'POS',
        checked: false,
    },
    {
        id: 8,
        name: 'Table',
        checked: false,
    },
    {
        id: 9,
        name: 'Tab',
        checked: false,
    },
];

export default sourceTypeData;
